import { Avatar } from "@certn/cascadia-react";
import { parseName } from "@certn/utils";
import { uniqBy } from "lodash";

import { UserDetails } from "../types";

interface Props {
  data: any[] | undefined;
  userDetails: UserDetails | undefined;
  includeAvatar: boolean;
  useIdAsKey: boolean;
  t: any;
}
export function sortPickerItems(props: Props) {
  const { data, userDetails, includeAvatar, useIdAsKey, t } = props;
  const pickerItems = uniqBy(data, "auth0_full_name")
    .filter(
      (requestor) =>
        userDetails?.auth0_id !== requestor.auth0_id &&
        requestor.auth0_id !== "Certn"
    )
    .map((requestor) => {
      const requestorFullName = requestor.auth0_full_name || "";
      const name = requestorFullName;

      return {
        id: useIdAsKey ? requestor.auth0_id : requestorFullName,
        name,
        leading: includeAvatar && (
          <Avatar name={parseName(requestor.auth0_full_name || undefined)} />
        ),
        full_name: requestor.auth0_full_name || undefined,
      };
    })
    .sort((a, b) => a.name.localeCompare(b.name));

  pickerItems.unshift({
    id: useIdAsKey ? userDetails?.auth0_id : userDetails?.auth0_full_name || "",
    name: `${userDetails?.auth0_full_name} (${t("me")})`,
    leading: includeAvatar && (
      <Avatar name={parseName(userDetails?.auth0_full_name || undefined)} />
    ),
    full_name: userDetails?.auth0_full_name || undefined,
  });

  return pickerItems;
}
